export const encodePriceListPathSegment = (value) =>
  encodeURIComponent(String(value)).replace(/\./g, '%2E')

export const buildPriceListApiUrl = (baseUrl, ...pathSegments) => {
  const path = pathSegments
    .map((segment) => {
      if (segment === undefined || segment === null || segment === '') {
        throw new Error('Path segment cannot be null, undefined, or empty')
      }

      return encodePriceListPathSegment(segment)
    })
    .join('/')

  return `${baseUrl}/${path}`
}
